<div class="mb-1" *ngIf="!isLoginPage" [ngClass]="{'mt-1rem':!isArchive}">
  <div class="ptb-archive" *ngIf="isArchive">
    <div class="mt-12 ml-1-5 archive-banner width-max-content">
      <div class="archive-btn">
        <span class="version-general-header">Archive Version : {{archiveVersion}}</span>
      </div>
      <div role="button" class="back-close-btn" tabindex="0" (click)="BackToCurrentContent()" (keyup.enter)="BackToCurrentContent()" tabindex="0">
        <img src="../../../assets/icons/arrow-left-blue.svg" class="current-content-back-arrow-icon" alt="Arrow Left">
        <span class="underline">Back to Current GARS Version</span>
      </div>
    </div>
  </div>
</div>
<div class="generalPage">
  <div class="p-6 pr-22 content-container print-content print-all-content">
    <h1 class="pendingheading content-blue">{{about_header}}</h1><br />
    <div class="answer content-blue width-100" id="about_content" [innerHTML]="about_content"></div><br />
    <h2 class="topic-heading font-20 content-blue">{{about_compatibilityHeader}}</h2><br />
    <div class="answer font-16 content-blue width-100" [innerHTML]="about_browsers"></div><br />
    <div class="answer font-16 content-blue width-100" id="about_otherApplications" [innerHTML]="about_otherApplications"></div>
  </div>
</div>
